// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFireOutlinedSvg from "@fishx/icons-svg/es/asn/PFireOutlined";
import FishxIcon from '../components/FishxIcon';

var PFireOutlined = function PFireOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFireOutlinedSvg
  }));
};

PFireOutlined.displayName = 'PFireOutlined';
export default React.forwardRef(PFireOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFireOutlined.js
// module id = 3418
// module chunks = 0